import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CareerFormLayer from "../components/CareerFormLayer";

const CareerFormPage = () => {
  return (
    <MasterLayout>
      <CareerFormLayer />
    </MasterLayout>
  );
};

export default CareerFormPage;
